export default __webpack_public_path__ + "static/media/games-banner-ms.ec94d005.webp";